import styled from '@emotion/styled';
import { Button } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';
import { ChangeEvent, createElement } from 'react';
import { withProps } from 'recompose';

type Props = ButtonProps & {
  onSelectFile: (e: ChangeEvent<HTMLInputElement>, files: FileList) => void;
};

const FileSelectButton = withProps(({ onSelectFile }: Props) => ({
  onChange: (e: ChangeEvent<HTMLInputElement>) => {
    if (e.currentTarget.files != null) {
      onSelectFile(e, e.currentTarget.files);
    }
  },
}))(({ children, onChange, onSelectFile, ...props }) => {
  // discard onSelectFile from props passing through to <Button>
  onSelectFile;

  return (
    <Root {...(props as any)}>
      {children}

      <Input type="file" onChange={onChange} />
    </Root>
  );
});

const Root = styled(Button)({
  position: 'relative',
});

const Input = styled('input')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  cursor: 'pointer',
  opacity: 0,
  overflow: 'hidden',
});

export default FileSelectButton;
